module.exports = __webpack_public_path__ + "static/eindruecke6-057c9cd3db7409aa69a51328badd14d4.jpg";